import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

export interface Language {
  code: string;
  name: string;
  nativeName: string;
  flagClass?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private readonly languages: Language[] = [
    { code: 'it', name: 'Italian', nativeName: 'Italiano', flagClass: 'fi fi-it' },
    { code: 'gb', name: 'English', nativeName: 'English', flagClass: 'fi fi-gb' },
    { code: 'ro', name: 'Romanian', nativeName: 'Română', flagClass: 'fi fi-ro' },
    { code: 'al', name: 'Albanian', nativeName: 'Shqip', flagClass: 'fi fi-al' },
    { code: 'pl', name: 'Polish', nativeName: 'Polski', flagClass: 'fi fi-pl' },
    { code: 'bg', name: 'Bulgarian', nativeName: 'Български', flagClass: 'fi fi-bg' }
  ];

  private currentLanguage: Language;
  private currentLanguageSubject = new BehaviorSubject<Language>(this.languages[0]);
  private translations: any = {};

  constructor(private http: HttpClient) {

    const savedLang = localStorage.getItem('selectedLanguage');
    const browserLang = navigator.language.substring(0, 2);
    const langCode = savedLang || browserLang;

    this.currentLanguage = this.languages.find(lang => lang.code === langCode) || this.languages[0];
    this.currentLanguageSubject.next(this.currentLanguage);
    this.loadTranslations(this.currentLanguage.code);
  }

  getLanguages(): Language[] {
    return this.languages;
  }

  getCurrentLanguage(): Language {
    return this.currentLanguage;
  }

  setLanguage(language: Language): void {
    this.currentLanguage = language;
    this.currentLanguageSubject.next(language);
    this.loadTranslations(language.code);
    localStorage.setItem('selectedLanguage', language.code);
  }

  getCurrentLanguage$(): Observable<Language> {
    return this.currentLanguageSubject.asObservable();
  }

  private loadTranslations(languageCode: string): void {
    this.http.get(`/assets/locale/${languageCode}.json`).subscribe({
      next: (translations) => {
        this.translations = translations;
      },
      error: (error) => {
        this.translations = {};
      }
    });
  }

  translate(key: string): string {
    return this.translations[key] || key;
  }

  getTranslations(): any {
    return this.translations;
  }
}